export default "__VITE_ASSET__4811eb24__"